const Location = ({ google_map_link, google_map_embed }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="h-100 md:h-125">
                <iframe
                    title="Google Map"
                    src={google_map_embed || ""} // Keep your src
                    className="w-full h-full"
                    style={{ border: "0" }}
                    allowFullScreen=""
                    loading="lazy"
                ></iframe>
            </div>
            <div className="flex flex-col justify-center p-12 md:p-20 text-white space-y-6">
                <h2 className="text-4xl Ethnocentric uppercase">Find us</h2>
                <p className="text-gray-300 text-lg leading-relaxed max-w-sm">
                    Conveniently located for easy access to all major logistic locations in Sharjah.
                </p>
                <a
                    href={google_map_link || "#"}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-block w-fit px-8 py-3 border-2 border-white ha:border-brand-500 text-white font-bold uppercase tracking-widest ha:bg-brand-500 transition-all rounded-lg"
                >
                    Get Directions
                </a>
            </div>
        </div>
    );
};

export default Location;